/**
 * Texto legível do `detail` que a API devolve.
 *
 * Desde a 1.20 o PUT da ficha e as respostas de pergunta recusam com `{message, erros}` ou
 * `{message, recusadas}` — e a tela mostrava "Erro ao salvar" (ou "[object Object]"), sem dizer
 * qual campo nem o formato esperado, que é exatamente o que a recusa traz.
 */
export function mensagemDoErro(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (!detail?.message) return fallback;
  const itens = detail.erros || [];
  if (!itens.length) return detail.message;
  const resto = itens.length > 1 ? ` (e mais ${itens.length - 1})` : '';
  return `${detail.message} ${itens[0]}${resto}`;
}
